import {
	AdMob, AdmobConsentStatus, InterstitialAdPluginEvents,
} from '@capacitor-community/admob';

import { AdProviderBase } from './AdProviderBase';

export default class CapacitorAdmob extends AdProviderBase {

	constructor(options) {
		super(options);
	}

	async setup() {
		if (this.isSetupLoading) {
			throw Error('Capacitor AdMob setup is in progress already');
		}

		this.isSetupLoading = true;

		await AdMob.initialize({
			initializeForTesting: this.isTesting,
			testingDevices: [],
		});

		const [trackingInfo, consentInfo] = await Promise.all([
			AdMob.trackingAuthorizationStatus(),
			AdMob.requestConsentInfo(),
		]);

		if (trackingInfo.status === 'notDetermined') {
			/**
			 * If you want to explain TrackingAuthorization before showing the iOS dialog,
			 * you can show the modal here.
			 * ex)
			 * const modal = await this.modalCtrl.create({
			 *   component: RequestTrackingPage,
			 * });
			 * await modal.present();
			 * await modal.onDidDismiss();  // Wait for close modal
			 **/

			await AdMob.requestTrackingAuthorization();
		}

		const authorizationStatus = await AdMob.trackingAuthorizationStatus();

		if (
			authorizationStatus.status === 'authorized' &&
			consentInfo.isConsentFormAvailable &&
			consentInfo.status === AdmobConsentStatus.REQUIRED
		) {
			await AdMob.showConsentForm();
		}

		AdMob.addListener(InterstitialAdPluginEvents.Loaded, () => {
			this.isInterstitialAdLoaded = true;
		});

		this.isSetup = true;
		this.isSetupLoading = false;
	}

	loadAd() {
		return AdMob.prepareInterstitial({
			adId: this.interstitialAdId,
		});
	}

	isAdLoaded() {
		return this.isInterstitialAdLoaded;
	}

	showAd() {
		if (!this.isAdLoaded()) {
			return;
		}

		this.isInterstitialAdLoaded = false;
		return AdMob.showInterstitial();
	}

	loadRewardedAd() {
		return AdMob.prepareRewardVideoAd({
			adId: this.rewardedAdId,
		});
	}

	showRewardedAd() {
		return AdMob.showRewardVideoAd();
	}
}
